import Vue from "vue";
import Vuex from "vuex";
import Router from "@/router/";
import axios from "axios";


Vue.use(Vuex);



//比较路由表和当前导航、并转向
const CompareRouter = {
  state: {
    routerList: Router.options.routes, //前台自己存页面路由表,从router中获取
    currentRouter: ""
  },
  mutations: {
    CompareRouter(state, name) {
      state.routerList.forEach(element => {
        if (element.children) {
          element.children.forEach(item => {
            if (item.name == name) {
              state.currentRouter = item.path;
              return false;
            }
          });
        } else {
          state.currentRouter = element.path;
          return false;
        }
        Router.push(state.currentRouter);
      });
    }
  }
};

//从任意页面跳转路由、传值
const RouterChange = {
  state: {
    routerList: Router.options.routes, //前台自己存页面路由表,从router中获取
    currentRouter: "",
    paramData: [] //页面间需要传递的值
  },
  mutations: {
    RouterChange(state, itemList) {
      state.routerList.forEach(element => {
        if (element.children) {
          element.children.forEach(item => {
            if (item.name == itemList.name) {
              state.currentRouter = item.path;
              return false;
            }
          });
        } else {
          state.currentRouter = element.path;
          return false;
        }
      });
      state.paramData = itemList;
    }
  }
};

//获取转译url
const URLPath={
  state:{
    URLPathData: ""
  },
  mutations:{
    URLPath(state,URL){
      let url = axios.defaults.baseURL + "/api/Flow/flow/GetShenQingDan_ByPath";
      axios.get(url, {
        params: {
          FilePath:URL,
        }
      }).then(function (response) {
        if(!response)return false;
        let _data = response.data;
        if (_data) {
          state.URLPathData=_data;
        }
      });
    }
  }
};

//路由进入业务列表，如果没有身份认证则跳转身份认证页面，同时调用本方法改变外层BaseLayout的当前active样式
const ChangeBaseLayoutActive = {
  state: {
    CurrentActive: localStorage.getItem("CurrentActive")?localStorage.getItem("CurrentActive"):0
  },
  mutations: {
    ChangeBaseLayoutActive(state, URL) {
      let _urlList=[{path:'PersonalBusinessList',label:'个人业务'},
        {path:'CompanyBusinessList',label:'单位业务'},
        {path:'AuthenticationList',label:'身份认证'},
        {path:'CidList',label:'户号查询'},
        {path:'BillPaymentList',label:'账单缴费'},
        {path:'ProgressSearchList',label:'进度查询'},
        {path:'ComplaintList',label:'投诉咨询'},
        {path:'AccountManagementList',label:'账号管理'},
        {path:'PublicAnnouncementList',label:'通知公告'},
        {path:'SalesNetworkList',label:'营业网点'},
        {path:'OperationManualList',label:'操作手册'}];
      if(URL){
        _urlList.forEach(function(item,index){
          if(item.path==URL){
            state.CurrentActive=index;
            localStorage.setItem("CurrentActive",index);
          }
        });
      }
    }
  }
};

import { Notice } from 'view-design';
Vue.prototype.$Notice= Notice;
import { domain } from '../api/apiConfig.js'
//获取角色信息
const GetSelectRole = {
  state: {
    Roles:[],
    CompanyRoles:[]
  },
  mutations: {
    GetSelectRole(state,obj) {
      //1个人2居民3企业
      let _userName=localStorage.getItem("S_UserFlag");
      let _userPhone=localStorage.getItem("S_UserPhone");
      if(!_userName&&!_userPhone){return false;}
      axios(domain.InApi+"api/wangting/UserInfo/SelectRoleData", {params: {I_Type: obj._I_Type}},"get").then(response=>{
        let _data = response.data;
        let _ReturnResult = JSON.parse(_data).ReturnMessage;
        if(obj._I_Type==3&&JSON.parse(_data).ReturnCode == false){
          axios(domain.InApi+"api/wangting/UserInfo/SelectRoleData", {params: {I_Type:1}},"get").then(resPersonalData=>{
            let _resData_personal = resPersonalData.data;
            if(JSON.parse(_resData_personal).ReturnCode == false){
              Notice.error({title: '提示',desc:'为了方便为您提供服务，请先身份认证'});
              ChangeBaseLayoutActive.state.CurrentActive=2;
              Router.push({path: "AuthenticationList", query: {currentPage: "personal"}});
              state.Roles=[];
            }else{
              Notice.error({title: '提示',desc:'为了方便为您提供服务，请先企业认证'});
              ChangeBaseLayoutActive.state.CurrentActive=2;
              Router.push({path: 'AuthenticationList', query: {currentPage: "company"}});
              state.CompanyRoles=[];
            }
          });
          return false;
        }
        if(obj._I_Type==2&&JSON.parse(_data).ReturnCode == false||(obj._I_Type==2&&!_ReturnResult)||(obj._I_Type==2&&_ReturnResult&&JSON.parse(_ReturnResult)[0].I_ISRenZheng != 4)){
          Notice.error({title: '提示',desc:'为了方便为您提供服务，请先身份认证'});
          ChangeBaseLayoutActive.state.CurrentActive=2;
          Router.push({path: "AuthenticationList", query: {currentPage: "personal"}});
          state.Roles=[];
          return false;
        }
        if(obj._I_Type==3&&JSON.parse(_data).ReturnCode == false){
          Notice.error({title: '提示',desc:'为了方便为您提供服务，请先企业认证'});
          ChangeBaseLayoutActive.state.CurrentActive=2;
          Router.push({path: 'AuthenticationList', query: {currentPage: "company"}});
          state.Roles=[];
          return false;
        }
        //I_ISRenZheng:  -3：个人认证失败， -2：深度认证失败 -1：简单审核失败 0：审核中 1：简单认证通过 2：深度审核中 3：深度认证过 4个人认证通过
        if(obj._I_Type==2){ //已通过简单认证的数据-居民
          let passAuthentication=JSON.parse(_ReturnResult).filter(n=>n.I_ISRenZheng=="4");
          state.Roles=passAuthentication;
          obj.NextPage?Router.push({path: '/ResidentBusiness', query: {currentPage:  obj.NextPage}}):"";
        }else if(obj._I_Type==3){ //已通过简单认证的数据-企业
          let _passArr=[-2,1,2,3];
          let passAuthenticationCom=JSON.parse(_ReturnResult).filter(n=>_passArr.indexOf(n.I_ISRenZheng)>-1);
          state.CompanyRoles=passAuthenticationCom;
          obj.NextPage?Router.push({path: '/CompanyBusiness', query: {currentPage:  obj.NextPage}}):"";
        }
      });
    }
  }
};

//获取数据字典
const GetBaseData = {
  state: {
    BaseData:[],
  },
  mutations: {
    GetBaseData(state,_I_Type) {
      //1个人2居民3企业
      if(!G_Roles){
        return false;
      }
      let G_Roles=localStorage.getItem("G_Roles");
      let _hasBaseData=localStorage.getItem("BaseData");
      if(_hasBaseData){
        state.BaseData=JSON.parse(_hasBaseData);
      }
      axios(domain.InApi+"api/BaoZhuang/BaoZhuang/SelectBaoZhuangDictionary", {params: {I_Type: _I_Type}},"get").then(response=>{
        if(!response)return false;
        let _data = JSON.parse(response.data);
        if (_data.length<=0) {return false;}
        state.BaseData=_data;
        localStorage.setItem("BaseData",JSON.stringify(_data));
      });

      // //1个人2居民3企业
      // let _userName=localStorage.getItem("S_UserFlag");
      // let _userPhone=localStorage.getItem("S_UserPhone");
      // if(!_userName&&!_userPhone){return false;}
      // let _hasBaseData=localStorage.getItem("BaseData");
      // if(_hasBaseData){
      //   state.BaseData=JSON.parse(_hasBaseData);
      // }else{
      //   axios(domain.InApi+"api/BaoZhuang/BaoZhuang/SelectBaoZhuangDictionary", {params: {I_Type: _I_Type}},"get").then(response=>{
      //     if(!response)return false;
      //     let _data = JSON.parse(response.data);
      //     if (_data.length<=0) {return false;}
      //     state.BaseData=_data;
      //     localStorage.setItem("BaseData",JSON.stringify(_data));
      //   });
      // }
    }
  }
};

//获取用户列表
const GetScid = {
  state: {
    S_CIDList:[],
  },
  mutations: {
    GetScid(state,newScid) {
      let _userName=localStorage.getItem("S_UserFlag");
      let _userPhone=localStorage.getItem("S_UserPhone");
      if(!_userName&&!_userPhone){return false;}
      if(newScid){
        if(state.S_CIDList.filter(n=>n.value==newScid.value).length<=0){
          state.S_CIDList.push(newScid);
        }
      }else{
        axios(domain.InApi+"api/WaterBill/WaterBill/GetUserList", {params: {OpenID: 1}},"get").then(response=>{
          if(!response)return false;
          let _data = response.data;
          if (!_data||_data.length<=0) {return false;}
          state.S_CIDList=[];
          _data.forEach(n=> state.S_CIDList.push({label:n.CustomerNO,value:n.CustomerNO}));
        });
      }
    }
  }
};


//热线字典
const GetWordsValue = {
  state: {
    Hotline:[]
  },
  mutations: {
    GetWordsValue(state,data) {
      state.Hotline=data;
    }
  }
};


//保存登录信息
const ChangeUserName = {
  state: {
      UserName:"",
  },
  mutations: {
    ChangeUserName(state,userName) {
      state.UserName=userName;
    }
  }
};

//登录注册modal是否显示
const CanShowModal = {
  state: {
    ModalStatus:false,
  },
  mutations: {
    CanShowModal(state,type) {
      state.ModalStatus=type;
    }
  }
};


//获取验证码混合验证
let Base64 = require('js-base64').Base64;
import $md5 from 'blueimp-md5'
const GetValidCode={
  state:{
    SendObj:"",
    pwd:""
  },
  mutations: {
    GetValidCode(state,phoneNum){
      let Num="";
      for(let i=0;i<5;i++){
        Num+=Math.floor(Math.random()*10);
      }
      let _phoneNum=phoneNum;
      let timestamp = (new Date())*1;
      Num = Num + (timestamp % 100000000);
      let _mixArr=["SHMS","FaSongYZM","Post",_phoneNum,Num,"SHMS","FaSongYZM","Post",_phoneNum,Num];
      let NumArr=Num.split("");
      let Token=[];
      NumArr.forEach(function(item){
        Token.push(_mixArr[item]);
      });
      let mixToken=Token.join("|");
      mixToken=$md5(mixToken);
      let _Secret={
        Phone:_phoneNum,
        Rule:Num,
        Token:mixToken
      };
      this.commit("RandomString",8);
      let _secret=Base64.encode(state.pwd+Base64.encode(JSON.stringify(_Secret)));
      let data = {
        Secret:_secret
      };
      axios.post(domain.InApi+"api/wangting/UserInfo/FaSongYZM", data).then(response=>{
        if(!response) return false;
        let _data=response.data;
        if(_data.ReturnCode==false){Notice.success({desc:'发送失败'});return false;}
        Notice.success({desc:'验证码已下发至您手机'});
      });
    },
    RandomString(state,len) {
      len = len || 32;
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz1234567890';
      let maxPos = chars.split("").length;
      let pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      state.pwd=pwd;
    },
  }
};

//20221222给手机号加密
const PhoneSecret={
    state:{
        SendObj:"",
        pwd:""
    },
    mutations: {
        PhoneSecret(state,phoneNum){
            let Num="";
            for(let i=0;i<5;i++){
                Num+=Math.floor(Math.random()*10);
            }
            let _phoneNum=phoneNum;
            let timestamp = (new Date())*1;
            Num = Num + (timestamp % 100000000);
            let _mixArr=["SHMS","FaSongYZM","Post",_phoneNum,Num,"SHMS","FaSongYZM","Post",_phoneNum,Num];
            let NumArr=Num.split("");
            let Token=[];
            NumArr.forEach(function(item){
                Token.push(_mixArr[item]);
            });
            let mixToken=Token.join("|");
            mixToken=$md5(mixToken);
            let _Secret={
                Phone:_phoneNum,
                Rule:Num,
                Token:mixToken
            };
            this.commit("RandomString",8);
            let _secret=Base64.encode(state.pwd+Base64.encode(JSON.stringify(_Secret)));
            state.SendObj=_secret;
        },
        RandomString(state,len) {
            len = len || 32;
            let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz1234567890';
            let maxPos = chars.split("").length;
            let pwd = '';
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos));
            }
            state.pwd=pwd;
        },
    }
};

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    CompareRouter,
    RouterChange,
    URLPath,
    ChangeBaseLayoutActive,
    GetSelectRole,
    ChangeUserName,
    GetWordsValue,
    CanShowModal,
    GetBaseData,
    GetScid,
    GetValidCode,
    PhoneSecret
  }
});